import { Navigate } from "react-router-dom";

const Research = () => {
  return <Navigate to="/sightings/adrian-shine-research" replace />;
};

export default Research;
